export enum TranslationFeature {
  PartnerProgram = 'partner-program',
  ProfessionalServices = 'professional-services',
  Subscriptions = 'subscriptions',
  SubscriptionsOld = 'subscriptions-old',
  PaymentManagement = 'payment-management',
  ExecutiveReports = 'executive-reports',
  OrganizationMapping = 'organization-mapping',
  Kaseya365SetupGuide = 'kaseya-365-setup-guide',
  AdminSettings = 'admin-settings',
  ThirdPartyIdp = 'third-party-idp',
  Support = 'support',
  TalentFinder = 'talent-finder',
  CooperBots = 'cooper-bots',
  ProfileSecurity = 'profile-security',
  Security = 'security',
  Onboarding = 'onboarding',
  Home = 'home',
  AutomationCenter = 'automation-center',
  AccessDenied = 'access-denied',
  EmailConfirmation = 'email-confirmation',
  ProductAccessDenied = 'product-access-denied',
  Logout = 'logout',
  Profile = 'profile',
  ProfileModuleManagement = 'profile-module-management',
  CooperInsights = 'cooper-insights',
  ReportCard = 'report-card',
  OrganizationModuleManagement = 'organization-module-management',
  SetupSummary = 'setup-summary',
  AccessGroups = 'access-groups',
  UserIdentityVerification = 'user-identity-verification',
  LegalTermsArchive = 'legal-terms-archive',
  ResetPassword = 'reset-password',
  SetPassword = 'set-password',
  RoleManagement = 'role-management',
}
